import { useEffect, useRef, useState } from "react";

import { useNavigate } from "react-router-dom";

import DashboardLayout from "../../../components/layout/DashboardLayout";

import ScaleMakeAsyncSelect from "../../../components/common/ScaleMakeAsyncSelect";

import ScaleModelAsyncSelect from "../../../components/common/ScaleModelAsyncSelect";

import { useCustomerViewModel } from "../../../viewmodels/operation/customer/useCustomerViewModel";

import { useServiceCallViewModel } from "../../../viewmodels/operation/servicecall/useServiceCallViewModel";

const CreateServiceCall = () => {
  const navigate = useNavigate();

  const [selectedMake, setSelectedMake] = useState<any>(null);
  const [selectedModel, setSelectedModel] = useState<any>(null);

  const { customers, setSearch } = useCustomerViewModel();

  const [_showAddressDropdown, _setShowAddressDropdown] = useState(false);

  const [_showPhoneDropdown, _setShowPhoneDropdown] = useState(false);

  const { createServiceCall } = useServiceCallViewModel();

  // ================= CUSTOMER =================
  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);

  const customerDropdownRef = useRef<any>(null);

  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);

  const [_selectedAddress, setSelectedAddress] = useState<any>(null);

  const [_selectedPhone, setSelectedPhone] = useState<any>(null);

  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",

    customerAddress: "",

    customerPhoneName: "",

    customerPhoneNumber: "",
  });

  // ================= SCALE =================

  const [manualScale, setManualScale] = useState({
    make: "",
    model: "",
    serialNumber: "",

    capacity: "",

    capacityValue: "",
    division: "",
    capacityUnit: "",
  });

  // ================= FORM =================
  const [form, setForm] = useState<any>({
    date: "",
    orderNumber: "",
    no: 1,

    customerComment: "",

    scaleCertified: false,
    scaleUsedForTrade: false,

    tmvCertificateNo: "",

    signatureCustomerName: "",
    customerSignature: "",
    customerSignedDate: "",

    technicianName: "",

    state: 0,
  });

  // ================= LOAN SCALE =================
  const [loanScale] = useState<any[]>([
    {
      make: "",
      model: "",
      serialNumber: "",
      capacity: "",
      signed: "",
      signedDate: "",
      haveScaleBeenReturned: 0,
      returnDate: "",
      scaleType: 0,
    },
  ]);

  // ================= TECHNICIANS =================
  const [technicians] = useState<any[]>([
    {
      dateWorked: "",
      hoursWorked: 0,
      arrival: "",
      depature: "",
      spareParts: "",
      qty: 0,
    },
  ]);

  // ================= OUTSIDE CLICK =================
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        customerDropdownRef.current &&
        !customerDropdownRef.current.contains(event.target)
      ) {
        // HIDE DROPDOWNS
        setShowCustomerDropdown(false);

        // CLEAR SELECTED
        setSelectedCustomer(null);

        setSelectedAddress(null);

        setSelectedPhone(null);

        // CLEAR MANUAL INPUT
        if (customerData.name.trim() === "") {
          setCustomerData({
            name: "",

            email: "",

            customerAddress: "",

            customerPhoneName: "",

            customerPhoneNumber: "",
          });
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [customerData.name]);

  // ================= SUBMIT =================
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {
      const payload = {
        date: form.date
          ? new Date(form.date).toISOString()
          : new Date().toISOString(),

        orderNumber: form.orderNumber,

        no: Number(form.no),

        customerComment: form.customerComment,

        scaleCertified: form.scaleCertified,

        scaleUsedForTrade: form.scaleUsedForTrade,

        tmvCertificateNo: form.tmvCertificateNo,

        customerId: selectedCustomer?.id || null,

        customerName: customerData.name,

        customerEmail: customerData.email,

        customerAddress: customerData.customerAddress,

        customerPhoneName: customerData.customerPhoneName,

        customerPhoneNumber: customerData.customerPhoneNumber,

        signatureCustomerName: form.signatureCustomerName,

        customerSignature: form.customerSignature,

        customerSignedDate: form.customerSignedDate
          ? new Date(form.customerSignedDate).toISOString()
          : null,

        technicianName: form.technicianName,

        state: Number(form.state),

        serviceCallScales: [
          {
            make: manualScale.make,

            model: manualScale.model,

            serialNumber: manualScale.serialNumber,

            capacity: manualScale.capacity,
          },
        ],

        loanScale: loanScale.map((x: any) => ({
          make: x.make,

          model: x.model,

          serialNumber: x.serialNumber,

          capacity: x.capacity,

          signed: x.signed,

          signedDate: x.signedDate
            ? new Date(x.signedDate).toISOString()
            : null,

          haveScaleBeenReturned: Number(x.haveScaleBeenReturned),

          returnDate: x.returnDate
            ? new Date(x.returnDate).toISOString()
            : null,

          scaleType: Number(x.scaleType),
        })),

        serviceCallTechnicians: technicians.map((x: any) => ({
          dateWorked: x.dateWorked
            ? new Date(x.dateWorked).toISOString()
            : null,

          hoursWorked: Number(x.hoursWorked),

          arrival: x.arrival ? new Date(x.arrival).toISOString() : null,

          depature: x.depature ? new Date(x.depature).toISOString() : null,

          spareParts: x.spareParts,

          qty: Number(x.qty),
        })),
      };

      const success = await createServiceCall(payload);

      if (success) {
        navigate("/service-calls");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <DashboardLayout>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Create Service Call</h1>

        <form onSubmit={handleSubmit} className="space-y-10">
          {/* ================= CUSTOMER DETAILS ================= */}
          <div className="bg-white border-2 border-slate-200 rounded-3xl p-8">
            <div className="space-y-5">
              {/* CUSTOMER NAME */}
              <div className="relative" ref={customerDropdownRef}>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Name
                </label>

                <input
                  required
                  value={customerData.name || ""}
                  onFocus={() => setShowCustomerDropdown(true)}
                  onChange={(e) => {
                    const value = e.target.value;

                    setCustomerData({
                      ...customerData,

                      name: value,
                    });

                    setSearch(value);

                    setShowCustomerDropdown(true);
                  }}
                  placeholder="Search customer or type manually"
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4 text-[16px]"
                />

                {/* CUSTOMER DROPDOWN */}
                {showCustomerDropdown && (
                  <div className="absolute z-50 bg-white border rounded-2xl shadow-xl w-full mt-2 max-h-72 overflow-auto">
                    <button
                      type="button"
                      onClick={() => setShowCustomerDropdown(false)}
                      className="w-full text-left px-4 py-4 bg-primary text-white font-semibold"
                    >
                      Manual Entry
                    </button>

                    {customers.map((x: any) => (
                      <button
                        key={x.id}
                        type="button"
                        onClick={() => {
                          const firstAddress = x.addresses?.[0];

                          const firstPhone = x.customerPhoneNumbers?.[0];

                          const fullAddress = [
                            firstAddress?.addressLine1,
                            firstAddress?.addressLine2,
                            firstAddress?.city,
                            firstAddress?.state,
                            firstAddress?.postalCode,
                          ]
                            .filter(Boolean)
                            .join(", ");

                          setSelectedCustomer(x);

                          setCustomerData({
                            name: x.name || "",

                            email: x.email || "",

                            customerAddress: fullAddress || "",

                            customerPhoneName: firstPhone?.name || "",

                            customerPhoneNumber: firstPhone?.phoneNumber || "",
                          });

                          setShowCustomerDropdown(false);
                        }}
                        className="w-full text-left px-4 py-4 border-b hover:bg-slate-100"
                      >
                        <div className="font-semibold">{x.name}</div>

                        <div className="text-sm text-slate-500">{x.email}</div>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* CUSTOMER COMMENT */}
              <div>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Comment
                </label>

                <textarea
                  rows={4}
                  value={form.customerComment || ""}
                  onChange={(e) =>
                    setForm({
                      ...form,

                      customerComment: e.target.value,
                    })
                  }
                  placeholder="Enter customer comment"
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                />
              </div>

              {/* EMAIL + CONTACT */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {/* EMAIL */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Customer Email
                  </label>

                  <input
                    value={customerData.email || ""}
                    onChange={(e) =>
                      setCustomerData({
                        ...customerData,

                        email: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>

                {/* CONTACT PERSON */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Contact Person
                  </label>

                  <input
                    value={customerData.customerPhoneName || ""}
                    onChange={(e) =>
                      setCustomerData({
                        ...customerData,

                        customerPhoneName: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>

                {/* PHONE */}
                <div>
                  <label className="block text-[15px] font-semibold mb-2">
                    Contact Phone Number
                  </label>

                  <input
                    value={customerData.customerPhoneNumber || ""}
                    onChange={(e) =>
                      setCustomerData({
                        ...customerData,

                        customerPhoneNumber: e.target.value,
                      })
                    }
                    className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                  />
                </div>
              </div>

              {/* ADDRESS */}
              <div>
                <label className="block text-[15px] font-semibold mb-2">
                  Customer Address
                </label>

                <textarea
                  rows={5}
                  value={customerData.customerAddress || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,

                      customerAddress: e.target.value,
                    })
                  }
                  className="w-full border-2 border-slate-300 rounded-2xl px-5 py-4"
                />
              </div>
            </div>
          </div>

          {/* ================= SCALE DETAILS ================= */}
          <div className="bg-white border rounded-3xl p-6 space-y-6">
            <div className="border-b pb-4">
              <h2 className="text-2xl font-bold">Scale Details</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="block mb-2 font-medium">Make</label>

                <ScaleMakeAsyncSelect
                  value={selectedMake}
                  onChange={(selected) => {
                    setSelectedMake(selected);

                    setManualScale((prev) => ({
                      ...prev,
                      make: selected?.label ?? "",
                    }));
                  }}
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Model</label>

                <ScaleModelAsyncSelect
                  value={selectedModel}
                  onChange={(selected) => {
                    setSelectedModel(selected);

                    setManualScale((prev) => ({
                      ...prev,
                      model: selected?.label ?? "",
                    }));
                  }}
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Serial Number</label>

                <input
                  value={manualScale.serialNumber}
                  onChange={(e) =>
                    setManualScale({
                      ...manualScale,
                      serialNumber: e.target.value,
                    })
                  }
                  className="w-full border rounded-xl px-4 py-3 uppercase"
                />
              </div>

              <div>
                <label className="block mb-2 font-medium">Capacity</label>

                <div className="grid grid-cols-3 gap-3">
                  {/* CAPACITY */}
                  <input
                    type="number"
                    min="0"
                    step="0.0001"
                    placeholder="3000"
                    value={manualScale.capacityValue || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value.startsWith("-")) return;

                      setManualScale({
                        ...manualScale,

                        capacityValue: value,

                        capacity:
                          value &&
                          manualScale.division &&
                          manualScale.capacityUnit
                            ? `${value}${manualScale.capacityUnit}x${manualScale.division}${manualScale.capacityUnit}`
                            : "",
                      });
                    }}
                    className="w-full border rounded-xl px-4 py-3"
                  />

                  {/* DIVISION */}
                  <input
                    type="number"
                    min="0"
                    step="0.0001"
                    placeholder="0.0005"
                    value={manualScale.division || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (value.startsWith("-")) return;

                      setManualScale({
                        ...manualScale,

                        division: value,

                        capacity:
                          manualScale.capacityValue &&
                          value &&
                          manualScale.capacityUnit
                            ? `${manualScale.capacityValue}${manualScale.capacityUnit}x${value}${manualScale.capacityUnit}`
                            : "",
                      });
                    }}
                    className="w-full border rounded-xl px-4 py-3"
                  />

                  {/* UNIT */}
                  <select
                    value={manualScale.capacityUnit}
                    onChange={(e) => {
                      const unit = e.target.value;

                      setManualScale({
                        ...manualScale,

                        capacityUnit: unit,

                        capacity:
                          manualScale.capacityValue && manualScale.division
                            ? `${manualScale.capacityValue}${unit}x${manualScale.division}${unit}`
                            : "",
                      });
                    }}
                    className="w-full border rounded-xl px-4 py-3"
                  >
                    <option value="">Unit</option>

                    <option value="t">t</option>

                    <option value="kg">kg</option>

                    <option value="g">g</option>

                    <option value="mg">mg</option>

                    <option value="lb">lb</option>

                    <option value="oz">oz</option>
                  </select>
                </div>

                {manualScale.capacity && (
                  <div className="mt-2 text-sm text-slate-600">
                    Capacity Sent:
                    <span className="font-semibold ml-2">
                      {manualScale.capacity}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* BUTTON */}
          <div className="flex justify-end gap-3 mt-6 pt-4">
            <button
              type="submit"
              className="px-8 py-3 rounded-2xl bg-primary text-white font-semibold"
            >
              Create Service Call
            </button>
          </div>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default CreateServiceCall;
